import IGetSiteDiaryResponseModel from "interfaces/Response/IGetSiteDiaryResponseModel";
import EventsAndIncidentsProps from "interfaces/SiteDiary/EventIncident/EventsAndIncidentsProps";

function mapSiteDiaryEventsAndIncidentsToViewModels(
  siteDiaryResponseModel: IGetSiteDiaryResponseModel,
  diarySaved: boolean,
  diaryDate: string,
  hwrcSiteId: string
): EventsAndIncidentsProps {
  const props: EventsAndIncidentsProps = {
    eventsAndIncidents: [],
    diarySaved,
    diaryDate,
    hwrcSiteId
  };

  if (
    siteDiaryResponseModel.siteDiary
    && siteDiaryResponseModel.siteDiary.eventsIncidents
  ) {
    props.eventsAndIncidents = siteDiaryResponseModel.siteDiary.eventsIncidents.map(entry => (
      {
        id: entry.id,
        timeRecorded: new Date(entry.timeRecorded),
        details: entry.details,
        hwrcSiteId,
        diaryDate
      }
    ));
  }

  return props;
}

export { mapSiteDiaryEventsAndIncidentsToViewModels };
